import * as Common from '@tfo/common'
import { Loader } from '@tfo/common'
import * as React from 'react'
import { Route, Redirect, RouteProps, useHistory } from 'react-router-dom'
import { useStore } from './hooks/useStore'
import { observer } from 'mobx-react'
import { useEffect } from 'react'
import { BackButton } from './components/back-button/BackButton'
import { GeneralTermsApproval } from './containers/general-terms-approval/GeneralTermsApproval'
const GENERAL_TERMS_APPROVAL_PATH = '/general-terms-approval'

const PrivateRoute = observer(({ exact = true, ...rest }: RouteProps) => {
	const { clientViewStore } = useStore()
	const history = useHistory()
	// Need to save the location pathname on initialize. 
	// there is some weird back-and-forth when redirecting to login new location pathname.
	const [returnUrl, _] = React.useState<string>(history.location.pathname)
	const cookie = Common.utils.getCookie()
	const userHasAcceptedGeneralTerms = cookie?.acceptedGeneralTerms

	useEffect(() => {
		if (history.location.pathname.includes('/new-report-order') || history.location.pathname.includes('/new-report-done')) {
			document.body.classList.add('hide-header')
		} else {
			document.body.classList.remove('hide-header')
		}	
	}, [history])
	

	return (
		Common.utils.loggedIn() && 
		clientViewStore?.company && 
		!userHasAcceptedGeneralTerms && 
		!history.location.pathname.includes(GENERAL_TERMS_APPROVAL_PATH) &&
		!clientViewStore?.externalHostedOrderFlow ?
			(<Redirect push to={{
				pathname: GENERAL_TERMS_APPROVAL_PATH,
				state: {
					returnUrl
				}
			}} />) :
			Common.utils.loggedIn() && 
			clientViewStore?.company && 
			!userHasAcceptedGeneralTerms && 
			history.location.pathname.includes(GENERAL_TERMS_APPROVAL_PATH) &&
			!clientViewStore.externalHostedOrderFlow ?
				(<Route exact path={GENERAL_TERMS_APPROVAL_PATH} component={GeneralTermsApproval} />) :
				Common.utils.loggedIn() && clientViewStore?.company?
					(<div >
						<BackButton />
						<Route exact={exact} {...rest} />
						{clientViewStore.loading && <Loader />}
					</div >) :
					Common.utils.loggedIn() && !clientViewStore?.company ?
						(
							<Loader />
						) :
						<Redirect push to={{
							pathname: "/login",
							state: {
								returnUrl
							}
						}} />
	)
})

export default PrivateRoute
